import { combineEpics } from 'redux-observable';

import cancelEventBookingEpic from './cancelEventBooking';
import eventBookingRegisterEpic from './eventBookingRegister';
import eventBookingRescheduleEpic from './eventBookingReschedule';

const eventBookingEpic = combineEpics(eventBookingRegisterEpic, cancelEventBookingEpic, eventBookingRescheduleEpic);

export default eventBookingEpic;
